import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { User } from '../../../types/Users.types';
import DeleteUserDialog from './DeleteAdminDialog';
import { Box, Card, Typography, Stack, Divider } from '@mui/material';

interface UsersTableMobileProps {
  users?: User[];
  impersonationLock: boolean;
  onDeleteUser: (email: string) => void;
}

export const AdminsTableMobile = ({
  users,
  impersonationLock,
  onDeleteUser,
}: UsersTableMobileProps) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={12} sx={{ mt: 24 }}>
      {users?.map((user: User) => (
        <Card
          variant="primary"
          key={`${user.email}-${user.app_metadata?.account}`}
          sx={{ '&:hover': { cursor: 'default' } }}
        >
          <Stack spacing={2}>
            <Box>
              <Typography variant="caption">
                {t('userManagement.account')}
              </Typography>
              <Typography variant="body1">
                {user.app_metadata?.account}
              </Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('userManagement.email')}
              </Typography>
              <Typography variant="body1">{user.email}</Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('userManagement.updatedAt')}
              </Typography>
              <Typography variant="body1">
                {dayjs(user.updated_at).format('YYYY-MM-DD')}
              </Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('userManagement.lastLogin')}
              </Typography>
              <Typography variant="body1">
                {user.last_login
                  ? dayjs(user.last_login).format('YYYY-MM-DD')
                  : '-'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
              <DeleteUserDialog
                disabled={impersonationLock}
                onClick={() => onDeleteUser(user.email)}
                showText={true}
              />
            </Box>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};
